import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Utils } from '../../../../../utils/utils';
import { CreateExcellenceLeverKpiPopupComponent } from './createexcellenceleverkpi-popup/createexcellenceleverkpi-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { CustomDialogService } from '../../../../../services/customdialog.service';
import { Router } from '@angular/router';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { BranchexcellenceChangelogFormComponent } from '../../branchexcellence-changelog-form/branchexcellence-changelog-form.component';
import { GroupFunctionRows } from '../group-function-rows';
import { ItemSelection } from '../item-selection';


@Component({
    selector: 'excellence-lever-kpi',
    templateUrl: './excellence-lever-kpi.component.html',
    styleUrls: ['./excellence-lever-kpi.component.less',
        '../branchexcellenceadmin.component.less',
        '../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class ExcellenceLeverKpiComponent implements OnInit {

    subscriptions: any[] = [];
    readonly groups = new GroupFunctionRows<ExcellenceLeverKpi>(visibleItems => this.selection.retain(visibleItems));
    columnsToDisplay = ['ExcellenceLever', 'KpiName', 'actions', 'ChangeLog'];

    isRemoveActive = false;
    readonly selection = new ItemSelection<ExcellenceLeverKpi>(item => item.ExcellenceLeverKpiId);

    constructor(
        private http: HttpClient
        , private dialogForm: MatDialog
        , @Inject('BASE_URL') private baseUrl: string
        , private toastrService: ToastrService
        , private router: Router
        , public defaults: DefaultValuesService
        , private customDialog: CustomDialogService
    ) { }

    ngOnInit(): void {
        // Just once to get user role in case of loading directly that component.
        // Remove actions item from columnsToDisplay
        if (!this.defaults.isMersyAdminBranchExcellenceUser)
            this.columnsToDisplay = this.columnsToDisplay.filter(item => item !== 'actions');
        this.getExcellenceLeversKpis();
    }

    getExcellenceLeversKpis() {
        Utils.httpGetExcellenceLeversKpis(
            this.http,
            this.baseUrl,
            this,
            function (tthis: ExcellenceLeverKpiComponent, list: ExcellenceLeverKpi[]) {
                tthis.groups.setItems(list);
            },
            null
        )
    }

    onRemoveExcellenceLeverKPI(element: ExcellenceLeverKpi) {
        this.customDialog.openConfirm({
            title: "Delete Excellence Factor",
            message: `Do you want to delete ${element.ExcellenceLever} - (${element.AccountId})?`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed) {
                Utils.httpDeleteExcellenceLeverKpi(
                    this.http
                    , this.baseUrl
                    , element.ExcellenceLeverKpiId
                    , this
                    , function (tthis: ExcellenceLeverKpiComponent, result: any) {
                        if (result) {
                            tthis.getExcellenceLeversKpis()
                            tthis.toastrService.success(`Excellence Lever KPI was deleted successfully!`);
                        }
                        else
                            tthis.toastrService.error(`Excellence Lever KPI could not be deleted. Please, contact with administrator`);
                    },
                    null
                );
            }
        });
    }

    onEditExcellenceLeverKPI(element: ExcellenceLeverKpi) {
        const dialog = this.dialogForm.open(CreateExcellenceLeverKpiPopupComponent, {
            panelClass: ['custom-mat-dialog_v2','dialogNgselect'],
            disableClose: true,
            data: element,
        })

        dialog.afterClosed().subscribe(() => {
            this.getExcellenceLeversKpis()
        })
    }

    openCreateExcellenceLeverKPIPopup() {
        const dialog = this.dialogForm.open(CreateExcellenceLeverKpiPopupComponent, {
            panelClass: ['custom-mat-dialog_v2','dialogNgselect'],
            disableClose: true,
            data: {},
        })

        dialog.afterClosed().subscribe(() => {
            this.getExcellenceLeversKpis()
        })
    }

    onClickDownload() {
        Utils.httpDownloadExcellenceFactors(
            this.http,
            this.baseUrl,
            `ExcellenceLever KPI`,
            'kpi');
    }

    onClickUpload() {
        this.router.navigate(["file/" + Utils.getFileUploadExcellenceLeverKPI()]);
    }

    onHistoryDetail(element: ExcellenceLeverKpi, type: string) {

        var excellenceLeverKpiId = 0;

        if (element.ExcellenceLeverKpiId != undefined)
            excellenceLeverKpiId = element.ExcellenceLeverKpiId;

        const Dialog = this.dialogForm.open(BranchexcellenceChangelogFormComponent, {
            disableClose: false,
            data: {
                element: element,
                id: excellenceLeverKpiId,
                dataType: type
            }
        });
        Dialog.afterClosed().subscribe(() => {
        });
    }

    public toggleRemoveLeverKpi() {
        this.setRemoveMode(!this.isRemoveActive);
    }

    private setRemoveMode(active: boolean) {
        this.isRemoveActive = active;
        this.selection.clear();
    }

    onClickBulkRemove() {
        const ids = this.selection.ids;
        this.customDialog.openConfirm({
            title: "Remove selected Lever KPIs",
            message: `Do you want to remove ${ids.length} selected Lever KPIs? Please note that action cannot be rollbacked!`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed === true) {
                Utils.httpDeleteExcellenceLeverKpis(
                    this.http
                    , this.baseUrl
                    , ids
                    , this
                    , function (tthis: ExcellenceLeverKpiComponent) {
                        tthis.toastrService.success('Excellence Lever KPIs were removed successfully!');
                        tthis.setRemoveMode(false);
                        tthis.getExcellenceLeversKpis();
                    },
                    function (tthis: ExcellenceLeverKpiComponent) {
                        tthis.toastrService.error('Excellence Lever KPIs could not be removed. Please, contact with administrator');
                    }
                );
            }
        })
    }
}
